module.exports = __webpack_public_path__ + "img/icon-tarjeta.6be0ff2e.svg";